export const PLATE = {
  paper: '#F4F7FB',
  rise: '#FBFCFE',
  rule: '#CBD5E1',
  steel: '#64748B',
  ink: '#0F172A',
};

export const RUBBER = {
  light: '#41505F',
  base: '#242F3D',
  dark: '#141B25',
  groove: '#0A0F16',
};

export const TYRE_STATES = {
  normal: { color: '#22C55E', edge: '#15803D', label: 'Normal', mark: '✓' },
  warning: { color: '#EAB308', edge: '#A16207', label: 'Due soon', mark: '◷' },
  due: { color: '#F97316', edge: '#C2410C', label: 'Retreading due', mark: '↻' },
  overdue: { color: '#EF4444', edge: '#B91C1C', label: 'Overdue', mark: '!' },
  damaged: { color: '#DC2626', edge: '#991B1B', label: 'Damaged', mark: '!' },
  failed: { color: '#B91C1C', edge: '#7F1D1D', label: 'Failed', mark: '×' },
  under_maintenance: { color: '#6366F1', edge: '#4338CA', label: 'Under maintenance', mark: '⌕' },
  data_unavailable: { color: '#64748B', edge: '#475569', label: 'Data unavailable', mark: '?' },
  empty: { color: '#94A3B8', edge: '#64748B', label: 'No tyre', mark: '−' },
};

export const STATE_ORDER = [
  'normal', 'warning', 'due', 'overdue', 'damaged', 'failed',
  'under_maintenance', 'data_unavailable', 'empty',
];

export const SELECTION = '#0F172A';

export const tyreState = (key) => TYRE_STATES[key] || TYRE_STATES.data_unavailable;

const STATUS_ALIASES = {
  maintenance: 'under_maintenance',
  retreading_due: 'due',
  re_treading_due: 'due',
};

export const statusOf = (position) => {
  if (!position?.current_fitment) return 'empty';
  const condition = String(position.current_fitment.condition || '')
    .trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (condition === 'failed' || condition === 'damaged') return condition;
  const status = String(position.current_fitment.alert_state || 'data_unavailable')
    .trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (STATUS_ALIASES[status]) return STATUS_ALIASES[status];
  return TYRE_STATES[status] ? status : 'data_unavailable';
};
